import {CustomerId} from '@shared/services/api/user-entity';
import {GQLPagingParamsVariableStartIndexRequired, GRAPHQL_TYPES} from '@shared/services/api/http-utility-service';

export type FaultModeId = number;

export interface FaultModeCreateBody {
  name: string;
  description: string | null;
  shared: boolean;
}

export interface FaultMode extends FaultModeCreateBody {
  fault_mode_id: FaultModeId;
  customer_id: CustomerId;
}

export const FAULT_MODES_OPERATION = 'fault_modes';
export const FAULT_MODE_FIELDS = ['fault_mode_id', 'name', 'description', 'shared', 'customer_id'];
export const FAULT_MODES_GRAPHQL_QUERY = {
  operation: FAULT_MODES_OPERATION,
  fields: FAULT_MODE_FIELDS,
  variables: {
    ...GQLPagingParamsVariableStartIndexRequired,
    fault_mode_id: {type: GRAPHQL_TYPES.INTEGER},
    fault_mode_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    name: {type: GRAPHQL_TYPES.STRING},
    names: {type: GRAPHQL_TYPES.STRING, list: true},
    shared: {type: GRAPHQL_TYPES.BOOLEAN}
  }
};

export interface FaultModeSearchTerm {
  fault_mode_id?: FaultModeId;
  fault_mode_ids?: FaultModeId[];
  name?: string;
  names?: string[];
  shared?: boolean;
}
